var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepLikePost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.807617,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#7043FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4593 28.5119C20.4016 28.5119 20.3441 28.5048 20.2882 28.4908C17.7897 27.8641 15.7225 26.7953 14.1447 25.3141C12.7886 24.0419 11.8239 22.4735 11.3557 20.7794C11.0182 19.5607 10.9474 18.3105 11.1513 17.17C11.3552 16.0296 11.8127 15.0771 12.476 14.4138C14.1475 12.7422 16.6479 12.7202 18.3822 13.4393C19.1758 13.7674 19.8499 14.2558 20.3322 14.8502C20.3757 14.9036 20.4174 14.9578 20.4574 15.0128C20.4977 14.9578 20.5396 14.9036 20.583 14.8502C21.0649 14.2558 21.7394 13.7678 22.533 13.4393C24.2674 12.7202 26.7696 12.7422 28.4393 14.4138C29.1025 15.0771 29.5605 16.03 29.7639 17.17C29.9674 18.31 29.8971 19.5607 29.5596 20.7794C29.0908 22.4735 28.1266 24.0414 26.7705 25.3141C25.1927 26.7953 23.1255 27.8641 20.6266 28.4908C20.5719 28.5045 20.5157 28.5116 20.4593 28.5119ZM16.1177 14.3828C15.0082 14.3828 14.0552 14.8211 13.4702 15.4061C12.4844 16.3943 12.1703 18.4497 12.7108 20.4049C13.1107 21.8496 13.9389 23.193 15.1071 24.2889C16.473 25.571 18.273 26.5103 20.4593 27.0832C22.646 26.5103 24.446 25.571 25.8119 24.2889C26.9796 23.193 27.8083 21.8514 28.2077 20.4049C28.7486 18.4497 28.4364 16.3943 27.4488 15.4061C26.575 14.5328 24.8833 13.9868 23.073 14.7368C21.8768 15.2322 21.1624 16.1257 21.1624 17.1274C21.1624 17.3139 21.0883 17.4927 20.9564 17.6246C20.8246 17.7564 20.6457 17.8305 20.4593 17.8305C20.2728 17.8305 20.0939 17.7564 19.9621 17.6246C19.8302 17.4927 19.7561 17.3139 19.7561 17.1274C19.7561 16.1257 19.0422 15.2322 17.846 14.7368C17.2988 14.506 16.7115 14.3858 16.1177 14.3828Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepLikePost);
export default __webpack_public_path__ + "static/media/step_like_post.78e1eb82cab15706965b4511b68c3d1b.svg";
export { ForwardRef as ReactComponent };